module.exports = __webpack_public_path__ + "img/1b_Dashboard.98910be3.png";